import React, { useState, useEffect, useCallback } from 'react';
import { showToast } from '../../services/ToastService';
import Heading from '../../components/Heading';
import { fetchEmails, EmailPagination } from '../../services/EmailService';
import styles from './EmailsOverview.module.css';
import cx from 'classnames';
import EmailListView from './EmailListView';
import Pagination from '../../components/Pagination';
import {Email} from "../../types/Email";

const EmailsOverview: React.FC = () => {
    const [emails, setEmails] = useState<Email[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState<EmailPagination | undefined>();

    const loadEmails = useCallback(async (page: number = 1) => {
        try {
            setIsLoading(true);
            const result = await fetchEmails(page, 10);
            setEmails(result.emails);
            setPagination(result.pagination);
        } catch (error) {
            console.error('Failed to load Emails:', error);
            showToast('Fehler beim Laden der E-Mails', 'error');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        loadEmails(currentPage);
    }, [currentPage]);

    const handlePageChange = useCallback((page: number) => {
        setCurrentPage(page);
    }, []);

    if (isLoading) {
        return (
            <div className={cx(styles['loading-container'])}>
                <div>Lade E-Mails...</div>
            </div>
        );
    }

    return (
        <div className={cx(styles['overview-container'])}>
            <div className={cx(styles['overview-header'])}>
                <Heading level={1} classes={cx(styles['overview-title'])}>E-Mail Verwaltung</Heading>
            </div>

            <div>
                {emails.length === 0 ? (
                    <div className={cx(styles['empty-state'])}>
                        <h3>Noch keine E-Mails vorhanden</h3>
                        <p>Es wurden noch keine Onboarding-Formulare eingereicht.</p>
                    </div>
                ) : (
                    <>
                        <EmailListView
                            emails={emails}
                        />
                        {pagination && pagination.totalPages > 1 && (
                            <div className={cx(styles['pagination-container'])}>
                                <Pagination
                                    totalPages={pagination.totalPages}
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default EmailsOverview;

